import { ChevronUpIcon } from "@heroicons/react/24/outline";
import { AnimatePresence, motion } from "framer-motion";
import clsx from "clsx";

export const Accordion = ({
    i,
    isOpen,
    onClick,
    children,
    leaderColor,
}: {
    i: string;
    isOpen: boolean;
    onClick: (i: string) => void;
    children: React.ReactNode;
    leaderColor?: string;
    scrollWithin?: boolean;
}) => {
    return (
        <div className="mb-2 ">
            <motion.header
                initial={false}
                onClick={() => onClick(i)}
                className={clsx(
                    "bg-accent h-8 w-full px-3",
                    "lozenge subdued flex cursor-pointer items-center justify-between",
                    isOpen && "mb-2",
                )}
            >
                <div className="flex items-center gap-2">
                    {leaderColor && (
                        <div
                            style={{ backgroundColor: leaderColor }}
                            className="size-2 shrink-0 rounded-full"
                        />
                    )}
                    {i}
                </div>
                <motion.div
                    animate={{ rotate: isOpen ? 0 : 180 }}
                    transition={{ duration: 0.2, ease: "easeInOut" }}
                >
                    <ChevronUpIcon className="size-4" />
                </motion.div>
            </motion.header>
            <AnimatePresence initial={false}>
                {isOpen && (
                    <motion.section
                        key="content"
                        initial="collapsed"
                        animate="open"
                        exit="collapsed"
                        variants={{
                            open: {
                                opacity: 1,
                                height: "auto",
                                transition: {
                                    opacity: {
                                        duration: 0.6,
                                        ease: [0.04, 0.62, 0.23, 0.98],
                                    },
                                    height: {
                                        duration: 0.2,
                                        ease: [0.04, 0.62, 0.23, 0.98],
                                    },
                                },
                            },
                            collapsed: {
                                opacity: 0,
                                height: 0,
                                transition: {
                                    opacity: {
                                        duration: 0.2,
                                        ease: [0.04, 0.62, 0.23, 0.98],
                                    },
                                    height: {
                                        duration: 0.6,
                                        ease: [0.04, 0.62, 0.23, 0.98],
                                    },
                                },
                            },
                        }}
                    >
                        {children}
                    </motion.section>
                )}
            </AnimatePresence>
        </div>
    );
};
